<script setup lang="ts">
import TheTechnologyEduLibCatItem from 'src/pages/Education/components/TheTechnologyEduLibCatItem.vue';
import {useI18n} from 'vue-i18n';

const {t} = useI18n();
</script>

<template>
  
  <!-- ROSA Knee -->
  <TheTechnologyEduLibCatItem :categoryGraphic="'/img/rosa-knee-edu-lib-graphic.png'"
                              class="rosa-knee"
                              path="Education.Technology.ROSAKnee"
                              titleGraphic="/img/rosa-knee-logo.png"
                              :titleGraphicAlt="t('rosa_education_rosa_knee_system_ios')" />
</template>

